/**
 * A socket's face by the IEC's letter, as a traveller recognises it: two flat slots for A, two
 * round holes for C, a T of three for G — the holes filled in a round face, 24 units square.
 */
type Hole =
  | { round: true; x: number; y: number; r: number }
  | { round: false; x: number; y: number; w: number; h: number; turn?: number };

const slot = (x: number, y: number, w: number, h: number, turn = 0): Hole => ({
  round: false,
  x,
  y,
  w,
  h,
  turn,
});
const hole = (x: number, y: number, r = 1.8): Hole => ({ round: true, x, y, r });

const FACES: Record<string, Hole[]> = {
  A: [slot(8, 8, 2, 8), slot(14, 8, 2, 8)],
  B: [slot(8, 6.5, 2, 7), slot(14, 6.5, 2, 7), hole(12, 17.5, 1.6)],
  C: [hole(8.5, 12), hole(15.5, 12)],
  D: [hole(8.5, 9.5), hole(15.5, 9.5), hole(12, 16.5, 2.3)],
  E: [hole(8.5, 12.5), hole(15.5, 12.5), hole(12, 7, 1.2)],
  F: [hole(8.5, 12), hole(15.5, 12), slot(11, 2.6, 2, 2.2), slot(11, 19.2, 2, 2.2)],
  G: [slot(11, 5.5, 2, 5.5), slot(6.5, 14, 4.5, 2), slot(13, 14, 4.5, 2)],
  H: [slot(7.5, 8, 2, 5.5, -30), slot(14.5, 8, 2, 5.5, 30), slot(11, 14, 2, 5)],
  I: [slot(7.5, 8.5, 2, 5.5, 30), slot(14.5, 8.5, 2, 5.5, -30), slot(11, 15, 2, 4)],
  J: [hole(7.5, 11), hole(16.5, 11), hole(12, 14)],
  K: [hole(8.5, 10), hole(15.5, 10), slot(11, 15, 2, 3.5)],
  L: [hole(7, 12, 1.6), hole(12, 12, 1.6), hole(17, 12, 1.6)],
  M: [hole(8.5, 9.5, 2.2), hole(15.5, 9.5, 2.2), hole(12, 16.5, 2.8)],
  N: [hole(8.5, 10.5), hole(15.5, 10.5), hole(12, 15.5)],
  O: [hole(8.5, 13), hole(15.5, 13), hole(12, 7.5)],
};

export function PlugIcon({ letter, size = 22 }: { letter: string; size?: number }) {
  return (
    <svg
      className="plug-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10.6" fill="none" stroke="currentColor" strokeWidth="1.5" />
      {(FACES[letter] ?? []).map((one, at) =>
        one.round ? (
          <circle key={at} cx={one.x} cy={one.y} r={one.r} fill="currentColor" />
        ) : (
          <rect
            key={at}
            x={one.x}
            y={one.y}
            width={one.w}
            height={one.h}
            rx="0.6"
            fill="currentColor"
            transform={
              one.turn
                ? `rotate(${String(one.turn)} ${String(one.x + one.w / 2)} ${String(one.y + one.h / 2)})`
                : undefined
            }
          />
        ),
      )}
    </svg>
  );
}
